import { Component, Input, OnInit } from '@angular/core';
import { AuthService, RmService } from '@bidi/common-services';
import * as es from 'date-fns/locale/es';
import { getTime } from 'date-fns';
import { RatingsService } from './../ratings.service';
import { createFeatureSelector, select, Store } from '@ngrx/store';
import { SetRatings } from './../ngrx/actions';

const locales = { es };
const placeholders = {
  es: 'Selecciona fecha'
};
const defaultFormat = {
  es: 'D/MM/YYYY'
};

@Component({
  selector: 'bidi-rank',
  templateUrl: './rank.component.html',
  styleUrls: ['./rank.component.scss']
})
export class RankComponent implements OnInit {
  @Input() role;
  @Input() resourceId;
  voteC = false;
  flagUser = true;
  userName = '';

  private state$ = this.store.pipe(select(createFeatureSelector('@bidi/common-components Ratings')));

  constructor (
    private rm: RmService,
    public auth: AuthService,
    public ratingsService: RatingsService,
    private store: Store<any>
  ) {
  }

  ngOnInit () {
    let userName = '';
    this.auth.userInfo$.subscribe(
      user => {
        if (user) {
          this.userName = user.preferred_username;
          userName = this.userName;
        }
      }
    );
    userName = this.userName;
    /*if (this.resourceId) {
      this.ratingsService.getRatings(this.resourceId);
      const resourceId = this.resourceId;
      let flagUser = true;
      this.ratingsService.ratings$.subscribe(
        data => {
          data.map(function (d) {
            if (d.id === resourceId) {
              if (d.ratings && d.ratings.length > 0) {
                d.ratings.map(function (r) {
                  if (userName === r.preferred_username) {
                    flagUser = false;
                  }
                });
              }
            }
          });
        }
      );
      this.flagUser = flagUser;
    }*/
  }

  voteContentShow () {
    this.voteC = !this.voteC;
  }

  voteContent (val) {
    const data = {
      'resource': this.resourceId,
      'range': val,
      'type': this.role
    }
    this.store.dispatch(new SetRatings(data));
    this.voteC = !this.voteC;
  }
}
